import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IO365CopilotChatUsage,
  ISearch,
} from '../../../services/o365/o365-copilot-chat-usage/o365-copilot-chat-usage.model';
import o365CopilotChatUsageService from '../../../services/o365/o365-copilot-chat-usage/o365-copilot-chat-usage.service';

export const searchO365CopilotChatUsage = createAsyncThunk(
  'searchO365CopilotChatUsage',
  async (searchParam?: ISearch) => {
    const response = await o365CopilotChatUsageService.searchO365CopilotChatUsage(searchParam).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const getO365CopilotChatUsageById = createAsyncThunk(
  'getO365CopilotChatUsageById',
  async (id: number) => {
    const response = await o365CopilotChatUsageService.getO365CopilotChatUsageById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const saveO365CopilotChatUsage = createAsyncThunk(
  'saveO365CopilotChatUsage',
  async (data: IO365CopilotChatUsage) => {
    const response = await o365CopilotChatUsageService.saveO365CopilotChatUsage(data).then((res) => {
      return res.body;
    });
    return response;
  }
);

export const deleteO365CopilotChatUsage = createAsyncThunk(
  'deleteO365CopilotChatUsage',
  async (id: number) => {
    const response = await o365CopilotChatUsageService.deleteO365CopilotChatUsage(id).then((res) => {
      return res.body;
    });
    return response;
  }
);
